import styled from 'styled-components';
import { breakpoints } from 'src/styles/theme';
import { rem } from 'polished';
import { PrePreOrderCheckoutTransitionOverlayTemplate } from './PrePreOrderCheckoutTransitionOverlayTemplate';

export const PrePreOrderCheckoutTransitionOverlayStyled = styled(PrePreOrderCheckoutTransitionOverlayTemplate)`
    background-color: #f5f5f5;
    height: calc(100vh - ${rem('340px')});
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;

    .container {
        width: 100%;
        max-width: ${rem('800px')};
        border-radius: ${rem('12px')};
        padding: ${rem('30px')};
        background: white;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .spinnerWrapper {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;

            .folderIcon {
                position: absolute;
            }

            .spinner {
                height: 60px;
                width: 60px;

                & > div {
                    height: inherit;
                    width: inherit;
                }
            }
        }

        .actionSection {
            display: flex;
            margin-top: ${rem('25px')};
            justify-content: space-between;
            margin-top: ${rem('25px')};
            margin-top: ${rem('25px')};
            align-items: end;
            width: 100%;

            @media (max-width: calc(${breakpoints.xs}px)) {
                flex-direction: column;
                align-items: center;
            }

            .wrapper {
                display: flex;
                flex-direction: column;
                justify-content: center;
                margin-top: ${rem('25px')};
                align-items: center;
                width: 100%;
                height: 100%;
                max-width: ${rem('240px')};
                text-align: center;

                a,
                button {
                    margin-top: ${rem('25px')};
                    width: fit-content;
                    min-width: ${rem('100px')};
                    border: 2px solid transparent;
                    background: ${({ theme }) => theme.colors.primary};
                    color: ${({ theme }) => theme.colors.white};
                    padding: ${rem('12px')};
                    font-size: ${rem('14px')};
                    cursor: pointer;
                    text-decoration: none;

                    &.call {
                        display: flex;
                        align-items: center;
                        background: unset;
                        color: ${({ theme }) => theme.colors.primary};
                        border-color: ${({ theme }) => theme.colors.primary};

                        svg {
                            width: ${rem('15px')};
                            height: ${rem('15px')};
                            margin-right: ${rem('10px')};

                            path {
                                fill: ${({ theme }) => theme.colors.primary};
                            }
                        }

                        &:hover {
                            background: ${({ theme }) => theme.colors.primary};
                            color: ${({ theme }) => theme.colors.white};

                            svg path {
                                fill: ${({ theme }) => theme.colors.white};
                            }
                        }
                    }

                    &:hover {
                        border-color: ${({ theme }) => theme.colors.primary};
                        color: ${({ theme }) => theme.colors.primary};
                        background: unset;
                    }
                }
            }
        }

        .failed {
            border: 1px solid ${({ theme }) => theme.colors.black};
            border-radius: 100%;
            width: 60px;
            height: 60px;
            display: flex;
            justify-content: center;
            align-items: center;

            span {
                display: contents;

                svg {
                    height: 25px;
                    width: 25px;
                }
            }
        }

        .success svg {
            height: 96px;
            width: 75px;
        }

        .subtitle,
        .title {
            width: 100%;
            max-width: ${rem('630px')};
            font-size: ${rem('18px')};
            font-weight: 500;
            line-height: 1.2;
            margin-top: ${rem('25px')};
            text-align: center;
        }

        .subtitle {
            font-weight: normal;
        }
    }
`;
